import { supabase } from '../lib/supabase/client';

export interface BookingConfirmationPayload {
  bookingId: string;
  patientName: string;
  // FUNC-126: paciente existente con email en ficha — sin patientEmail, el
  // Edge Function resuelve el destinatario server-side con consultaId + RUT.
  patientEmail?: string;
  consultaId?: string;
  patientRut?: string;
  patientPhone?: string;
  therapistName: string;
  therapistEmail: string;
  // FUNC-113 Fase 2 — N° de registro del terapeuta (dato público, RNPI).
  therapistRegistroSuperintendencia?: string;
  therapistNumeroLicencia?: string;
  serviceName: string;
  therapyType: 'individual' | 'pareja' | 'familia';
  date: string;
  time: string;
  duration: number;
  price: number;
  modality: 'presencial' | 'online' | 'ambas' | 'domicilio';
  motivoConsulta?: string;
  nombrePareja?: string;
  direccion?: string;
  meetLink?: string;
  metodoPagoDeclarado: 'efectivo' | 'transferencia' | 'tarjeta';
  // Pago anticipado Transbank
  anticipo_monto?: number;
  anticipo_deadline?: string;
  payment_link?: string;
}

export interface CancellationPayload {
  patientName: string;
  // FUNC-126: paciente existente con email en ficha — sin patientEmail, el
  // Edge Function resuelve el destinatario server-side con consultaId + RUT.
  patientEmail?: string;
  consultaId?: string;
  patientRut?: string;
  therapistName: string;
  therapistEmail: string;
  date: string;
  time: string;
  modality: string;
  canceladoPor?: 'paciente' | 'terapeuta';
}

export interface ReschedulePayload {
  patientName: string;
  // FUNC-126: paciente existente con email en ficha — sin patientEmail, el
  // Edge Function resuelve el destinatario server-side con consultaId + RUT.
  patientEmail?: string;
  consultaId?: string;
  patientRut?: string;
  therapistName: string;
  therapistEmail: string;
  oldDate: string;
  oldTime: string;
  newDate: string;
  newTime: string;
  modality: string;
}

export interface ContactFormPayload {
  name: string;
  email: string;
  phone: string;
  reason: string;
  origin: string;
  therapistName?: string;
}

async function invoke(type: string, data: Record<string, unknown>): Promise<boolean> {
  try {
    const { error } = await supabase.functions.invoke('send-email', {
      body: { type, data },
    });
    if (error) {
      console.error(`[EmailService] Error enviando ${type}:`, error.message);
      return false;
    }
    return true;
  } catch (err) {
    console.error(`[EmailService] Error inesperado en ${type}:`, err);
    return false;
  }
}

export const EmailService = {
  async sendBookingConfirmation(payload: BookingConfirmationPayload): Promise<void> {
    await Promise.allSettled([
      invoke('booking-confirmation-patient', payload as unknown as Record<string, unknown>),
      invoke('booking-confirmation-therapist', payload as unknown as Record<string, unknown>),
    ]);
  },

  async sendCancellationNotification(payload: CancellationPayload): Promise<void> {
    await Promise.allSettled([
      invoke('cancellation-patient', payload as unknown as Record<string, unknown>),
      invoke('cancellation-therapist', payload as unknown as Record<string, unknown>),
    ]);
  },

  async sendRescheduleNotification(payload: ReschedulePayload): Promise<void> {
    await Promise.allSettled([
      invoke('reschedule-patient', payload as unknown as Record<string, unknown>),
      invoke('reschedule-therapist', payload as unknown as Record<string, unknown>),
    ]);
  },

  async sendContactForm(payload: ContactFormPayload): Promise<boolean> {
    return invoke('contact-form-admin', payload as unknown as Record<string, unknown>);
  },
};
